<mat-form-field class="dynamicForm_alignment" [formGroup]="group">
  <mat-label>{{field.labelName}}</mat-label>
  <input matInput [formControlName]="field.labelCode" type="text" (keydown.tab)="OnEnter($event)"
    (keyup.enter)="OnEnter($event)" (ngModelChange)="valuechanges($event)" (keydown.backspace)="clearOnBackSpace(field.labelCode)" (keydown.delete)="clearOnBackSpace(field.labelCode)" autocomplete="off"
    [matAutocomplete]="auto" tabindex="0" [required]="isRequired" [readonly]="field.disabled">
    <mat-autocomplete #auto="matAutocomplete" (opened)="broadcastService.onOpenDropDownOrderForm()" (closed)="broadcastService.onCloseDropDownOrderForm()"
      tabindex="-1" (optionSelected)="selectionOptionChanged($event)">
      @for (item of (massDropdown | async); track item) {
        <mat-option [id]="item.code">{{getValueAndCode(item, field.labelCode)}}</mat-option>
      }
      @if (noData) {
        <mat-option id="{{noRecord}}">
          No records found.
        </mat-option>
      }
    </mat-autocomplete>
    @if (field.disabled) {
      <span class="mat-error disabled-error">There are no values in the dropdown</span>
    }
    @for (validation of field.validations; track validation) {
      <ng-container ngProjectAs="mat-error">
        @if (group.get(field.labelCode).hasError(validation.name.toLocaleLowerCase()) && !(group.get(field.labelCode).hasError(required))) {
          <mat-error>{{validation.message}}</mat-error>
        }
        @if (group.get(field.labelCode).hasError(required)) {
          <mat-error>{{field.labelName}} is mandatory</mat-error>
        }
        @if (group.get(field.labelCode).hasError(invalid)) {
          <mat-error></mat-error>
        }
      </ng-container>
    }
    @if (group.get(field.labelCode).hasError('invalidAutocompleteObject') && !group.get(field.labelCode).hasError(required)) {
      <mat-error>Please select
      from the given options</mat-error>
    }
  </mat-form-field>

